// @ts-check
// Campos obrigatórios para avançar no funil (docs/arquitetura-appcrm/08-contrato-modelo-de-dados.md, seção 6).
import { api } from './api-client.js';

/**
 * @typedef {'CARD' | 'CONTACT' | 'STUDENT' | 'STUDENT_PERSON'} RequirementScope
 * @typedef {{ key: string, scope: RequirementScope, objectNameSingular: string, fieldName: string, label: string, isEnabled: boolean,
 *   fromStage: string | null, effectiveFromStage: string | null, defaultFromStage: string | null, updatedAt: string | null }} StageRequirement
 * @typedef {{ key: string, scope: RequirementScope, objectNameSingular: string, fieldName: string, label: string, recordId: string | null,
 *   opportunityStudentId?: string | null, studentLabel?: string, currentValue?: any }} MissingRequirement
 */

/** @returns {Promise<{ stageRequirements: StageRequirement[], canEdit: boolean }>} */
export async function fetchStageRequirements() {
  const body = await api.get('/rest/stage-requirements');
  return body?.data ?? { stageRequirements: [], canEdit: false };
}

/**
 * @param {string} key @param {{ isEnabled?: boolean, fromStage?: string | null }} patch
 * @returns {Promise<StageRequirement>}
 */
export async function updateStageRequirement(key, patch) {
  const body = await api.patch(`/rest/stage-requirements/${encodeURIComponent(key)}`, patch);
  return body?.data?.stageRequirement;
}

/**
 * O que falta para o card entrar na etapa, sem gravar nada.
 * @param {string} recordId @param {string} stage
 * @returns {Promise<MissingRequirement[]>}
 */
export async function checkStageRequirements(recordId, stage) {
  const body = await api.get('/rest/stage-requirements/check', { recordId, stage });
  return body?.data?.missing ?? [];
}
